import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import api from '../services/api';

const Checkout = () => {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (!user) {
      navigate('/login');
      return;
    }
    const startCheckout = async () => {
      try {
        // Fetch user details to get plan info
        const userRes = await api.get('/api/user/me');
        if (!userRes.data.success) throw new Error('Unable to fetch user');
        const { planName, monthlyPrice } = userRes.data.user;

        if (!planName || !monthlyPrice) {
          throw new Error('Pricing not available. Please contact support.');
        }

        const res = await api.post(
          '/api/create-checkout-session',
          { planName, monthlyPrice }
        );
        // Redirect to Stripe-hosted Checkout
        window.location.href = res.data.checkoutUrl;
      } catch (err) {
        console.error(err);
        // Fallback to dashboard
        navigate('/dashboard');
      }
    };
    startCheckout();
  }, [user, navigate]);

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
      <div className="text-center space-y-3">
        <div className="loader mx-auto mb-4"></div>
        <h2 className="text-xl font-semibold">Redirecting to secure payment...</h2>
        <p className="text-gray-500 text-sm">Please wait, do not close this tab.</p>
      </div>
    </div>
  );
};

export default Checkout; 